import { render, staticRenderFns } from "./SendFailDialog.vue?vue&type=template&id=4dc494f1&scoped=true"
import script from "./SendFailDialog.vue?vue&type=script&lang=js"
export * from "./SendFailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc494f1",
  null
  
)

export default component.exports